<template>
	<div class="main-body">
		<!-- <h1>Main:{{ this.$route.query.id }}</h1> -->
		<!-- 左侧点击菜单 -->
		<div class="main-leftMenu">
			<!-- 切换菜单部分 -->
			<div class="main-leftMenu-up">
				<router-link
					tag="div"
					to="/main/tpys"
					:class="{
						'main-leftMenu-up-div': $route.path == '/main/tpys',
						'main-leftMenu-up-div_en': $app.language,
					}"
				>
					<img
						:src="
							$route.path != '/main/tpys'
								? require('../../mycomponents/img/left-menu-before/icon h tpys.svg')
								: require('../../mycomponents/img/left-menu-after/icon h tpys 1.svg')
						"
						alt=""
					/><span>{{ $t("picturecompression") }}</span>
				</router-link>
				<router-link
					tag="div"
					to="/main/spys"
					:class="{
						'main-leftMenu-up-div': $route.path == '/main/spys',
						'main-leftMenu-up-div_en': $app.language,
					}"
				>
					<img
						:src="
							$route.path != '/main/spys'
								? require('../../mycomponents/img/left-menu-before/icon h spys.svg')
								: require('../../mycomponents/img/left-menu-after/icon h spys 1.svg')
						"
						alt=""
					/><span>{{ $t("videocompression1") }}</span>
				</router-link>
				<router-link
					tag="div"
					to="/main/pdfys"
					:class="{
						'main-leftMenu-up-div': $route.path == '/main/pdfys',
						'main-leftMenu-up-div_en': $app.language,
					}"
				>
					<img
						:src="
							$route.path != '/main/pdfys'
								? require('../../mycomponents/img/left-menu-before/icon h pdfys.svg')
								: require('../../mycomponents/img/left-menu-after/icon h pdfys 1.svg')
						"
						alt=""
					/><span>PDF {{ $t("compress1") }}</span>
				</router-link>
				<router-link
					tag="div"
					to="/main/wordys"
					:class="{
						'main-leftMenu-up-div': $route.path == '/main/wordys',
						'main-leftMenu-up-div_en': $app.language,
					}"
				>
					<img
						:src="
							$route.path != '/main/wordys'
								? require('../../mycomponents/img/left-menu-before/icon h wordys.svg')
								: require('../../mycomponents/img/left-menu-after/icon h wordys 1.svg')
						"
						alt=""
					/><span>Word {{ $t("compress1") }}</span>
				</router-link>
				<router-link
					tag="div"
					to="/main/pptys"
					:class="{
						'main-leftMenu-up-div': $route.path == '/main/pptys',
						'main-leftMenu-up-div_en': $app.language,
					}"
				>
					<img
						:src="
							$route.path != '/main/pptys'
								? require('../../mycomponents/img/left-menu-before/icon h pptys.svg')
								: require('../../mycomponents/img/left-menu-after/icon h pptys 1.svg')
						"
						alt=""
					/><span>PPT {{ $t("compress1") }}</span>
				</router-link>
			</div>

			<!-- 静态推荐部分 -->
			<div class="main-leftMenu-down">
				<P v-if="!$app.language">{{ $t("featuredproductrecommendation") }}</P>
				<div class="main-leftMenu-down-div" v-if="!$app.language">
					<div class="main-leftMenu-down-div-all">
						<a
							href="https://www.xunjiepdf.com/converter"
							@click="
								gevt('功能页特色产品推荐', '点击事件', '迅捷PDF转换器', 'None', 'None', 'None')
							"
							target="_blank"
						>
							<img src="./../../mycomponents/img/home/icon tj pdf.svg" alt="" /><span>{{
								$t("fastpdfconverter")
							}}</span>
						</a>
					</div>
					<div class="main-leftMenu-down-div-all">
						<a
							href="https://www.xunjiepdf.com/editor"
							@click="
								gevt('功能页特色产品推荐', '点击事件', '迅捷PDF编辑器', 'None', 'None', 'None')
							"
							target="_blank"
						>
							<img src="./../../mycomponents/img/home/icon_tj_pdfbj.svg" alt="" /><span>{{
								$t("fastpdfeditor")
							}}</span>
						</a>
					</div>
					<div class="main-leftMenu-down-div-all">
						<a
							href="https://www.xunjiepdf.com/ocr"
							@click="
								gevt(
									'功能页特色产品推荐',
									'点击事件',
									'迅捷OCR文字识别软件',
									'None',
									'None',
									'None'
								)
							"
							target="_blank"
						>
							<img src="./../../mycomponents/img/home/icon tj ocr.svg" alt="" /><span>{{
								$t("text035")
							}}</span>
						</a>
					</div>
				</div>
				<div class="main-leftMenu-down-a" :class="{'main-leftMenu-down-a_en': $app.language}">
					<a
						href="https://www.xunjiepdf.com/compress"
						@click="gevt('功能页左下角', '点击事件', '官方网站', 'None', 'None', 'None')"
						target="_blank"
						>{{ $t("officialwebsite") }}</a
					>
					<a
						href="https://ruanjian.qiyukf.com/client?k=9f6be7423510fa866bf322613deaf43d&wp=1&qtype=4485250&1049844"
						@click="gevt('功能页左下角', '点击事件', '在线客服', 'None', 'None', 'None')"
						target="_blank"
						>{{ $t("onlineservice") }}</a
					>
				</div>
			</div>
		</div>
		<!-- 右侧主要内容 -->
		<div class="main-right">
			<!-- 动态组件-根据点击的不同进入不同状态的相同组件 且必须缓存-->
			<div class="main-right-components">
				<keep-alive>
					<router-view ref="ys" @openLimitBody="openLimitBody"></router-view>
				</keep-alive>
			</div>
			<!-- 底部设置 -->
			<div class="main-right-footer">
				<!--footer-left -->
				<div class="main-right-footer-div">
					<span class="main-right-footer-div-s1">{{ $t("saveto") }}</span>
					<input
						type="radio"
						id="default-file"
						v-model="$local.outputOriginDir"
						value="true"
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="default-file"
						><span>{{ $t("originalfolder") }}</span></label
					>
					<input
						type="radio"
						id="self-file"
						v-model="$local.outputOriginDir"
						value=""
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="self-file"
						><span>{{ $t("custom") }}</span></label
					>
					<input
						type="text"
						id="self-file-url"
						:disabled="!!$local.outputOriginDir || !$app.isYsOver || !$app.isDrOver"
						v-model="$local.outputPath"
						:title="$local.outputPath"
					/>
					<!-- <img src="./../../mycomponents/img/main-footer/icon_bcwjj01@2x(1).png" alt="" /> -->
					<div
						class="main-right-footer-div-chooseFile"
						@click="!!!$local.outputOriginDir && $app.isYsOver && $app.isDrOver && pickDir()"
						:class="{
							'main-right-footer-div-chooseFile-disable':
								!!!$local.outputOriginDir && $app.isYsOver && $app.isDrOver,
						}"
					></div>
				</div>
				<!--footer-right -->
				<button
					class="main-right-footer-btn"
					@click="run(true)"
					:disabled="!$app.isYsOver || !$app.isDrOver"
				>
					{{ !$app.isYsOver ? $t("incompression") : $t("startcompression") }}
					<!-- 开始压缩 -->
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import hdapi from "../../common/hdapi";
import LimitiMain from "../dialogs/Limit";
import TojpgLimit from "../dialogs/TojpgLimit";
import CompressOver from "../dialogs/CompressOver";
import gevt from "../../plugins/gevt";
import {store} from "../../plugins";

const fs = require("fs");
const iconv = require("iconv-lite");

export default {
	name: "Main",
	data() {
		return {
			nowVIPlevel: this.$app.VIPlevel,
			limit_time: "",
		};
	},
	methods: {
		pickDir() {
			return hdapi.pickDir(this.$local.outputPath).then((x) => {
				if (!x) return;
				this.$local.outputOriginDir = "";
				this.$local.outputPath = x;
			});
		},
		gevt(a, b, c, d, e, f) {
			gevt(a, b, c, d, e, f);
		},
		async run(force) {
			// console.log("this.$refs.ys.runner", this.$refs.ys);
			if (this.$refs.ys && this.$refs.ys.runner.files.length > 0) {
				if (
					(this.$route.path == "/main/pdfys" ||
						this.$route.path == "/main/pptys" ||
						this.$route.path == "/main/wordys") &&
					hdapi.platform == "WIN"
				) {
					var main_path = await hdapi.getPath("main");
					// main_path = main_path.split("\\");
					main_path = hdapi.split(main_path);
					main_path.splice(-1, 1);
					// main_path = main_path.join("\\");
					main_path = hdapi.arrayjoin(main_path);
					// let reg_out = `${main_path}\\net.reg`;
					let reg_out = hdapi.join(main_path, "net.reg");
					// console.log("reg_out", reg_out);
					let is_Net;
					is_Net = await hdapi
						.exec(
							`regedit /e ${reg_out} "HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\NET Framework Setup\\NDP"`
						)
						.then(() => {
							let aa = fs.readFileSync(reg_out);
							if (aa) {
								let ss = iconv.decode(aa, "UTF-16LE");
								if (
									ss.indexOf(`"Version"="3.0`) == -1 &&
									ss.indexOf(`"Version"="3.5`) == -1 &&
									ss.indexOf(`"Version"="2.0`) == -1
								) {
									console.log("net文件不存在");
									// hdapi.unlink(reg_out);
									return false;
								} else {
									console.log("net文件存在");
									hdapi.unlink(reg_out);
									return true;
								}
							} else {
								return false;
							}
						});
					// console.log("is_net", is_Net);
					if (!is_Net) {
						// hdapi.exec("PdfCompressProcess.exe");
						this.$app.isNet = false;
						// return;
					} else {
						this.$app.isNet = true;
					}
				}
				this.$app.isYsOver = false;
				let runner = this.$refs.ys.runner;
				runner.nowFileArry = [];
				if (runner._ysType == "图片压缩") runner.isToJpgLimit = 0;
				// console.log(this.$app.VIPlevel);
				let {outputPath, outputOriginDir} = this.$local;
				let xjdir;
				let dirName = hdapi.basename(outputPath);
				if (!outputOriginDir && dirName != this.$app.productName) {
					console.log("dirname", dirName);
					if (
						dirName == "C:" ||
						dirName == "D:" ||
						dirName == "E:" ||
						dirName == "F:" ||
						dirName == "G:"
					) {
						xjdir = hdapi.join(dirName, this.$app.productName);
					} else xjdir = hdapi.join(this.$local.outputPath, this.$app.productName);
					let isXjdir = await hdapi.exists(xjdir);
					// console.log("Xjdir", xjdir);
					if (!isXjdir) {
						// console.log("this.$local.outputPath", this.$local.outputPath);
						let createXjdir = await hdapi
							.mkdirs(xjdir)
							.then((res) => {
								console.log("文件创建成功", res);
								return true;
							})
							.catch((err) => {
								console.error(this.$t("filecreationfail"), err);
								return false;
							});
						// console.log("createXjdir", createXjdir);
						if (!createXjdir) {
							return;
						}
					}
					outputPath = xjdir;
				}
				this._limit_open = false;
				var limit_size = 2 * 1024 * 1024;
				if (this.$route.path == "/main/tpys") {
					limit_size = 200 * 1024;
				}
				// console.log("limit_size", limit_size);
				return runner
					.run({
						outputPath,
						outputOriginDir,
						limitSize: this.$app.VIPlevel || this.$app.language ? Infinity : limit_size,
						force,
						onError: (err) => {
							if (err == "SIZE_LIMIT") {
								if (this._limit_open) return;
								this._limit_open = true;
								this.$app.theWayToShop = runner._ysType + "_开始压缩_限制弹窗";
								this.openLimitBody();
							} else {
								console.error(err);
							}
						},
					})
					.then((res) => {
						// console.log("压缩结束且没有出错");
						store.isYsOver = true;
						if (runner._ysType == "图片压缩") {
							if (runner.isToJpgLimit > 0) {
								this.opentojpglimitBody();
							} else if (
								this.$app.VIPlevel == 0 &&
								this._limit_open == false &&
								!this.$app.language
							) {
								this.openCompressOverBody();
							}
						} else {
							if (this.$app.VIPlevel == 0 && this._limit_open == false && !this.$app.language) {
								this.openCompressOverBody();
							}
						}
					})
					.catch((err) => {
						// console.log("压缩结束且出错", err);
						store.isYsOver = true;
					});
			}
			return Promise.reject("no runner");
		},
		//打开Limit模态框
		async openLimitBody() {
			await this.$dlg.show(LimitiMain);
			// console.log(this.$app.VIPlevel);
			if (this.$app.VIPlevel) {
				let that = this;
				this.limit_time = setInterval(async function () {
					if (store.isYsOver) {
						await that.run();
						clearInterval(that.limit_time);
					}
				}, 1000);
			}
		},
		async opentojpglimitBody() {
			// console.log("runner.isToJpgLimit", this.$refs.ys.runner.isToJpgLimit);
			await this.$dlg.show(TojpgLimit);
		},
		async openCompressOverBody() {
			await this.$dlg.show(CompressOver);
		},
	},
	mounted() {},
};
</script>

<style lang="less" scoped>
/* main-body */
.main-body {
	height: 100%;
	width: 100%;
}
.main-body::after {
	height: 100%;
	content: "";
	vertical-align: middle;
	display: inline-block;
}

/* 左侧点击菜单 */
.main-leftMenu {
	width: 223rem;
	box-sizing: border-box;
	padding: 0 32rem 0 16rem;
	height: 100%;
	display: inline-block;
	background-color: #f8f8f8;
	position: relative;
	vertical-align: middle;
}
/* 左侧菜单上部分 */
.main-leftMenu-up {
	margin-top: 9rem;
}
.main-leftMenu-up div {
	/* text-align: center; */
	height: 43rem;
	box-sizing: border-box;
	width: 175rem;
	background: #f8f8f8;
	/* filter: blur(30rem); */
	opacity: 1;
	border-radius: 8rem;
	cursor: pointer;
	padding-left: 14rem;
	margin-bottom: 17rem;
}
.main-leftMenu-up div:hover {
	background: #ffffff;
	/* opacity: 0.4; */
}
/* 被点击时的样式 */
.main-leftMenu-up-div {
	background: #ffffff !important;
}
.main-leftMenu-up img {
	z-index: 99;
}
.main-leftMenu-up div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-leftMenu-up div span {
	vertical-align: middle;
	/* width: 62rem; */
	/* height: 20rem; */
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.main-leftMenu-up div img {
	vertical-align: middle;
	height: 24rem;
	width: 24rem;
	margin-right: 10rem;
}

/* 左侧菜单下部分 */
.main-leftMenu-down {
	position: fixed;
	bottom: 35rem;
	/* width: 180rem; */
	overflow: hidden;
	left: 0rem;
	padding-left: 30rem;
}
.main-leftMenu-down p {
	/* width: 97rem; */
	/* height: 24rem; */
	font-size: 16rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-bottom: 19rem;
}

.main-leftMenu-down-div {
	/* margin-top: 15rem; */
	margin-bottom: 35rem;
}

.main-leftMenu-down-div-all {
	height: 20rem;
	/* padding: 2rem 0rem 2rem 15rem; */
	cursor: pointer;
}
.main-leftMenu-down-div-all a {
	text-decoration: none;
}
.main-leftMenu-down-div-all:nth-of-type(1),
.main-leftMenu-down-div-all:nth-of-type(2) {
	margin-bottom: 20rem;
}
/* .main-leftMenu-down-div-all:hover {
	background-color: #e4ecf8;
	color: #52a9f8;
} */
.main-leftMenu-down-div-all:hover span {
	text-decoration: underline;
}
.main-leftMenu-down-div-all::after {
	content: "";
	height: 100%;
	vertical-align: middle;
	display: inline-block;
}
.main-leftMenu-down-div-all span {
	vertical-align: middle;
	/* width: 85rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.main-leftMenu-down-div-all img {
	vertical-align: middle;
	margin-right: 10rem;
	width: 20rem;
	height: 20rem;
	border-radius: 2rem;
}

.main-leftMenu-down-a {
	/* padding-left: 28rem; */
}
.main-leftMenu-down-a a {
	/* width: 48rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 13rem; */
	color: #1b212e;
	text-decoration: underline;
	/* letter-spacing: 10rem; */
	opacity: 1;
}

.main-leftMenu-down-a a:nth-of-type(2) {
	margin-left: 35rem;
}
.main-leftMenu-down-a a:hover {
	color: #006de0;
}
/* 右侧主要内容 */
/* right-body */
.main-right {
	display: inline-block;
	width: calc(100% - 223rem);
	box-sizing: border-box;
	padding-right: 24rem;
	padding-top: 8rem;
	height: 100%;
	background-color: #f8f8f8;
	position: relative;
	vertical-align: middle;
}
.main-right::after {
	content: "";
	/* clear: both; */
}

/* right-main */
.main-right-components {
	background-color: #ffffff;
	width: 100%;
	box-sizing: border-box;
	/* padding-left: 13rem; */
	border-radius: 8rem;
	height: calc(100% - 88rem);
}

/* 右侧底部 */
.main-right-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
	box-sizing: border-box;
	/* padding-left: 50rem; */
	background-color: #f8f8f8;
	height: 88rem;
}

.main-right-footer::after {
	content: "";
	height: 100%;
	/* clear: both; */
	display: inline-block;
	vertical-align: middle;
}

.main-right-footer-div {
	display: inline-block;
	vertical-align: middle;
	// margin-right: 190rem;
}
.main-right-footer-div * {
	display: inline-block;
	vertical-align: middle;
}
.main-right-footer-div-s1 {
	/* width: 40rem;
	height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 24rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-right: 27rem;
}
.main-right-footer-div label,
span {
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}
.main-right-footer-div label {
	cursor: pointer;
	/* width: 48rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 24rem; */
	color: rgba(27, 33, 46, 1);
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.main-right-footer-div input:disabled + label {
	color: rgba(92, 112, 153, 1);
}
#self-file-url {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	outline: none;
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	color: #1b212e;
	opacity: 1;
	&:focus {
		border: 1rem solid #006de0;
		// border: none;
	}
}
.main-right-footer-div label:nth-of-type(1) {
	margin-right: 28rem;
}
.main-right-footer-div input[type="text"] {
	margin-left: 16rem;
	margin-right: 8rem;
	width: 270rem;
	height: 26rem;
	border: 1rem solid #768ebe;
	opacity: 1;
	box-sizing: border-box;
	padding-left: 9rem;
	border-radius: 2rem;
}
/* 改变radio样式 */
.main-right-footer-div input[type="radio"] {
	position: absolute;
	opacity: 0;
	display: block;
}
.main-right-footer-div input[type="radio"] + label::before {
	content: "";
	width: 15rem;
	height: 15rem;
	display: inline-block;
	vertical-align: middle;
	background-size: cover;
	margin-right: 9rem;
	background-image: url("./../../mycomponents/img/main-footer/icon_yssz_sx01.svg");
}
.main-right-footer-div input[type="radio"]:checked + label::before {
	background-image: url("./../../mycomponents/img/main-footer/icon_scgs_jpj01.svg");
}
// .main-right-footer-div input[type="radio"]:disabled + label::before {
// 	background-image: url("./../../mycomponents/img/main-footer/icon_yssz_sx02@2x.png");
// }

.main-right-footer-div-chooseFile {
	height: 24rem;
	width: 24rem;
	background-image: url("./../../mycomponents/img/main-footer/icon bcwjj01 (2).svg");
	background-size: cover;
	cursor: pointer;
}
.main-right-footer-div-chooseFile-disable {
	background-image: url("./../../mycomponents/img/main-footer/icon bcwjj01 (3).svg");
}
.main-right-footer-div-chooseFile-disable:hover {
	background-image: url("./../../mycomponents/img/main-footer/icon bcwjj01 (2).svg");
}
.main-right-footer-div-chooseFile-disable:active {
	background-image: url("./../../mycomponents/img/main-footer/icon bcwjj01.svg");
}
.main-right-footer-btn {
	/* display: inline-block; */
	vertical-align: middle;
	// float: right;
	// margin-right: 24rem;
	position: absolute;
	right: 24rem;
	top: 50%;
	transform: translateY(-50%);
	width: 200rem;
	height: 57rem;
	background: #006de0;
	opacity: 1;
	border-radius: 11rem;
	font-size: 16rem;
	font-family: MicrosoftYaHei;
	color: #ffffff;
	border: none;
	opacity: 1;
	cursor: pointer;
	outline: none;
}
.main-right-footer-btn:hover {
	background: #1081f8;
}
.main-right-footer-btn:active {
	background: #0064ce;
}
.main-right-footer-btn:disabled {
	background: rgba(188, 202, 225, 1);
}

@media screen and (max-height: 636px) {
	.main-leftMenu-down-div-all a span {
		font-size: 14.16rem !important;
	}
	.main-leftMenu-down-a a {
		font-size: 14.16rem !important;
	}
	.main-right-footer-div * {
		font-size: 14.16rem !important;
	}
	.main-right-footer-div label {
		display: inline-flex;
		align-items: center;
	}
	.main-right-footer-div {
		display: inline-flex;
		align-items: center;
	}
}
// en
.main-leftMenu-up-div_en {
	span {
		font-size: 14rem !important;
		font-family: Arial !important;
	}
}
.main-leftMenu-down-a_en {
	display: flex;
	// margin-bottom: 4rem;
	flex-direction: column;
	a {
		font-family: Arial;
		&:nth-of-type(1) {
			margin-bottom: 20rem;
		}
		&:nth-of-type(2) {
			margin-left: 0;
		}
	}
}
</style>
